import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { BadgeModule } from '../../../../shared/components/badge';
import { MypageMenuListItemComponent } from './my-page-menu-list-item.component';

@NgModule({
  declarations: [MypageMenuListItemComponent],
  exports: [MypageMenuListItemComponent],
  imports: [CommonModule, RouterModule, NgbCollapseModule, NzIconModule, BadgeModule],
})
export class MypageMenuListItemModule {}
